/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditSupportBulkUploadAvgFilesMutationRequest, AuditSupportBulkUploadAvgFilesMutationResponse, AuditSupportBulkUploadAvgFiles401, AuditSupportBulkUploadAvgFiles403 } from "../models/AuditSupportBulkUploadAvgFiles";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { auditSupportBulkUploadAvgFiles } from "../axios/auditSupportBulkUploadAvgFiles";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const auditSupportBulkUploadAvgFilesMutationKey = () => [{ url: '/audit-support/v1/avg-files/bulk-upload' }] as const

export type AuditSupportBulkUploadAvgFilesMutationKey = ReturnType<typeof auditSupportBulkUploadAvgFilesMutationKey>

export function auditSupportBulkUploadAvgFilesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AuditSupportBulkUploadAvgFilesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = auditSupportBulkUploadAvgFilesMutationKey()
        return mutationOptions<AuditSupportBulkUploadAvgFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadAvgFiles401 | AuditSupportBulkUploadAvgFiles403>, {data: AuditSupportBulkUploadAvgFilesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return auditSupportBulkUploadAvgFiles(data, config)
          },
        })

}

/**
 * @description Upload multiple files for processing and storage. Files are processed sequentially.
 * @summary Bulk upload AVG files
 * {@link /audit-support/v1/avg-files/bulk-upload}
 */
export function useAuditSupportBulkUploadAvgFiles<TContext>(options: 
{
  mutation?: UseMutationOptions<AuditSupportBulkUploadAvgFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadAvgFiles401 | AuditSupportBulkUploadAvgFiles403>, {data: AuditSupportBulkUploadAvgFilesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AuditSupportBulkUploadAvgFilesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? auditSupportBulkUploadAvgFilesMutationKey()

          const baseOptions = auditSupportBulkUploadAvgFilesMutationOptions(config) as UseMutationOptions<AuditSupportBulkUploadAvgFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadAvgFiles401 | AuditSupportBulkUploadAvgFiles403>, {data: AuditSupportBulkUploadAvgFilesMutationRequest}, TContext>
          

          return useMutation<AuditSupportBulkUploadAvgFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadAvgFiles401 | AuditSupportBulkUploadAvgFiles403>, {data: AuditSupportBulkUploadAvgFilesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AuditSupportBulkUploadAvgFilesMutationResponse, ResponseErrorConfig<AuditSupportBulkUploadAvgFiles401 | AuditSupportBulkUploadAvgFiles403>, {data: AuditSupportBulkUploadAvgFilesMutationRequest}, TContext>
      
}